import React from 'react';
import './About.css';

const About = () => (
  <section className="about">
    <div className="about-container">
      <h2>Sobre a Frios & Cia</h2>
      <p>
        A Frios & Cia Atacado e Distribuidora é especializada na comercialização e distribuição de frios, congelados, bebidas, polpas de frutas, salgados e muito mais, garantindo qualidade, variedade e ótimo custo-benefício para nossos clientes.
      </p>
      <p>
        Compromisso sólido em oferecer produtos frescos e selecionados diariamente para estabelecimentos comerciais, restaurantes, lanchonetes e consumidores que buscam praticidade e excelência em seus pedidos.
      </p>
      <p>
        Nosso catálogo inclui laticínios, embutidos, polpas naturais, salgados congelados, bebidas e ingredientes essenciais para o seu dia a dia. Prezamos pela logística eficiente, garantindo entregas ágeis e seguras para facilitar seu abastecimento.
      </p>
      <p>
        Atendimento especializado e equipe preparada para suporte e soluções personalizadas. Destaque pelo compromisso com a satisfação dos clientes e busca contínua por inovação no setor de alimentos.
      </p>
    </div>
  </section>
);

export default About;
